import { useDataProvider } from "ra-core";
import { useEffect, useState } from "react";

const useOneBranch = (id) => {
  const [branch, setBranch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();
  useEffect(() => {
    async function getOneBranch(id) {
      try {
        const branch = await dataProvider.getOne("merchant-branches", {
          id: id,
        });
        setBranch(branch.data);
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        return setError(error);
      }
    }

    setLoading(true);
    getOneBranch(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { branch, loading, error };
};

export default useOneBranch;
